export default "__VITE_ASSET__Dd0106d2__"